var $0ffe850a38a6abb3$exports = {};
$0ffe850a38a6abb3$exports = {
    "colorFormat": `Fargeformat`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$0ffe850a38a6abb3$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
